var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faCog, faDatabase, faExchangeAlt, faRedo, faSave, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {} from "axios";
import { BAlert, BButton, BTab, BTabs } from "bootstrap-vue";
import { onMounted, ref } from "vue";
import { fetchDatasetAttributes } from "@/api/datasets";
import { setAttributes } from "@/components/DatasetInformation/services";
import { useHistoryStore } from "@/stores/historyStore";
import localize from "@/utils/localization";
import Heading from "../Common/Heading.vue";
import FormDisplay from "@/components/Form/FormDisplay.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetAttributes',
    props: {
        datasetId: null
    },
    setup(__props) {
        const props = __props;
        library.add(faBars, faCog, faDatabase, faExchangeAlt, faRedo, faSave, faUser);
        const historyStore = useHistoryStore();
        const loading = ref(false);
        const loadingFailed = ref(false);
        const messageText = ref();
        const messageVariant = ref("danger");
        const formData = ref({});
        const datasetAttributes = ref({});
        function onAttribute(data) {
            formData.value["attribute"] = data;
        }
        function onConversion(data) {
            formData.value["conversion"] = data;
        }
        function onDatatype(data) {
            formData.value["datatype"] = data;
        }
        function onPermission(data) {
            formData.value["permission"] = data;
        }
        function onError(message) {
            messageText.value = message;
            messageVariant.value = "danger";
        }
        function submit(key, operation) {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield setAttributes(props.datasetId, formData.value[key], operation);
                    messageText.value = response.message;
                    messageVariant.value = response.status;
                    historyStore.loadCurrentHistory();
                }
                catch (e) {
                    const error = e;
                    onError(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.err_msg) || "Unable to save dataset attributes.");
                }
            });
        }
        function loadDatasetAttributes() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const data = yield fetchDatasetAttributes(props.datasetId);
                    datasetAttributes.value = data;
                }
                catch (e) {
                    const error = e;
                    loadingFailed.value = true;
                    onError(((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.err_msg) || "Unable to fetch available dataset attributes.");
                }
                finally {
                    loading.value = false;
                }
            });
        }
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield loadDatasetAttributes();
        }));
        return { __sfc: true, props, historyStore, loading, loadingFailed, messageText, messageVariant, formData, datasetAttributes, onAttribute, onConversion, onDatatype, onPermission, onError, submit, loadDatasetAttributes, faBars, faCog, faDatabase, faExchangeAlt, faRedo, faSave, faUser, FontAwesomeIcon, BAlert, BButton, BTab, BTabs, localize, Heading, FormDisplay, LoadingSpan };
    }
});
